export const events = {
  addReactionStart: 'Add reaction start',
  addReactionCancel: 'Add reaction cancel',
  writeCommentStart: 'Write comment start',
  writeCommentSubmit: 'Write comment submit',
  scrollCommunitiesFeed: 'Scroll communities feed',
  goToPost: 'Go to post',
  createPostContinue: 'Create post continue',
  createPostEdit: 'Create post edit',
  createPostSubmit: 'Create post submit',
  createPostCancel: 'Create post cancel',
  sendClapsStart: 'Send claps start',
  sendClapsCancel: 'Send claps cancel',
  sendClapsSubmit: 'Send claps submit',
  sendClapsEdit: 'Send claps edit',
}
